import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import {
  handleDefaultMarketplace,
  handleProfileOrMarketplaceChangeRedirects,
} from "../../../utils/handleDefaultMarketplace";
import { useHistory } from "react-router";

export const useSetOrgId = () => {
  const history = useHistory();
  return useMutation({
    mutationFn: async (orgId: number) => {
      await apiClient.putOrgId({ id: orgId });
    },
    onSuccess: async () => {
      await handleDefaultMarketplace();
      handleProfileOrMarketplaceChangeRedirects(history);
      window.location.reload();
    },
  });
};
